import { createClient } from 'microcms-js-sdk';

export const client = createClient({
  serviceDomain: 'nagara-container',
  apiKey: 'qCB2HQgsrLm1Gj74j57Q2eY8fB1oKuoAVZTS',
});